import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'textScripts',
    standalone: false
})
export class TextScriptsPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }
  transform(value: string, ...args: unknown[]): unknown {
    return this.domSanitizer.bypassSecurityTrustHtml(
      value.replace(/\^(\S*?)\^/g, '<sup>$1</sup>').replace(/\~(\S*?)\~/g, '<sub>$1</sub>')
    );
  }
}
